import React from 'react';
import { withRouter } from 'react-router-dom';
import IssLogo from '../assets/img/iss_icon.png';
import AppStoreBadge from '../assets/img/app-store-badge.png';
import GooglePlayBadge from '../assets/img/google-play-badge.png';
import styles from 'iss/styles/AppStoreLinksPage.styl';
import { translate } from '../strings';

// Display store links for LuurISSa mobile apps
const AppStoreLinksPage = withRouter(class extends React.Component {
  state = {
    backendError: null
  };
  render() {
    return (

      <div className={styles.storePage}>
        <div className={styles.storePageHeader}>
          <img src={IssLogo} alt="ISS logo" />
        </div>

        <h3 className={styles.storePageTitle}>{translate('appStoreLinksPage.title')}:</h3>

        <div className={styles.storeBadges}>
          <StoreBadge
            link='https://play.google.com/store/apps/details?id=fi.iss.laadunseuranta'
            alt='Get it on Google Play'
            img={GooglePlayBadge}
          />
        </div>
        <div className={styles.storeBadges}>
          <StoreBadge
            link='https://apple.co/3K2iZG2'
            alt='Download on the App Store'
            img={AppStoreBadge}
          />
        </div>

        <div className={styles.storeFooter}>
          <h6 className={styles.storeFooterText}>Google Play and the Google Play logo are trademarks of Google LLC.</h6>
          <p>&#169; 2023 ISS Palvelut Oy</p>
        </div>
      </div>
    );
  }
});

class StoreBadge extends React.Component {
  render() {
    return (
      <div className={styles.storeBadge}>
        <a href={this.props.link}><img alt={this.props.alt} src={this.props.img} /></a>
      </div>
    );
  }
}

export default AppStoreLinksPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/AppStoreLinksPage.jsx